export const useStoreDancer = defineStore('StoreDancer', {
    state: () => ({
        dancer: null,
        disabled: null,
        error: null,
    }),
    actions: {
        async getDancer(idDancer) {
            this.error = null;
            if (this.dancer?.id_dancer !== parseInt(idDancer)) {
                this.dancer = null;
            }
            ({dancer: this.dancer, error: this.error} = await useEntityDancer().get(idDancer));
        },
        updateDancerField({field, value}) {
            if (this.dancer[field] === undefined)
                throw new Error('Attempted to update a dancer field which does not exist (' + field + ').');
            this.dancer[field] = value;
        },
        async putDancer() {
            this.error = null;
            this.disabled = true;
            ({dancer: this.dancer, error: this.error} = await useEntityDancer().put(
                this.dancer.id_dancer,
                this.dancer,
            ));
            this.disabled = false;
        },
        async deleteDancer() {
            this.error = null;
            ({error: this.error} = await useEntityDancer().remove(this.dancer.id_dancer));
            if (this.error) return;
            await navigateTo('/dancers');
        },
        clearError() {
            this.error = null;
        },
    },
});
